import { useAppSelector } from '../../store/hooks'

export const useStatus = () => {
  const status = useAppSelector((state) => state.status)
  return status
}
